// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import { DesignPackageProductCardPage_OptionCombinationFragmentDoc } from './design-package-configurator/DesignPackageProductCardPage.generated';
import { MaterialAttributeValuesForFilterFragmentDoc } from './personalization-option/EditPersonalizationOptionWizard.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditPersonalizationOptionPageQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  rpogId: Types.Scalars['ID']['input'];
  isAdd: Types.Scalars['Boolean']['input'];
  forTliId: Types.Scalars['ID']['input'];
  hasTliId: Types.Scalars['Boolean']['input'];
}>;


export type EditPersonalizationOptionPageQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', readyPlanOptionGroupPersonalizationType: Array<{ __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string }> }, designPackage: { __typename?: 'DesignPackage', id: string, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, availableTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, groupByFeature: boolean, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }, takeoffLineItem?: { __typename?: 'TakeoffLineItem', id: string, personalizationSlotOrder?: number | null | undefined, name: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined }, readyPlan?: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, marketingDescription?: string | null | undefined, levels?: number | null | undefined, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, groupByFeature: boolean, personalizationTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }>, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, personalizationRpoShadowPlaceholder?: { __typename?: 'TakeoffLineItem', id: string, products: Array<{ __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, placeholder?: { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined } | null | undefined, location: { __typename?: 'Location', id: string } }> } | null | undefined, personalizationPlaceholderControlledSlots: Array<{ __typename?: 'TakeoffLineItem', personalizationSlotOrder?: number | null | undefined, id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> }> }>, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, personalizationTargetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }> }> }> } };

export type EditPersonalizationOptionPage_MaterialVariantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditPersonalizationOptionPage_MaterialVariantQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } };

export type EditPersonalizationOptionPage_CombinationsQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  targetGroupIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type EditPersonalizationOptionPage_CombinationsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> } };

export type EditPersonalizationOptionPage_OptionCombinationFragment = { __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type EditPersonalizationOptionPage_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> };

export type EditPersonalizationOptionPage_Slot_TakeoffLineItemFragment = { __typename?: 'TakeoffLineItem', personalizationSlotOrder?: number | null | undefined, id: string, name: string, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, products: Array<{ __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> };

export type EditPersonalizationOptionPage_ProductFragment = { __typename?: 'TakeoffLineItem', id: string, active: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> };

export type SavePersonalizationRpogMutationVariables = Types.Exact<{
  input: Types.SavePersonalizationOptionGroupInput;
}>;


export type SavePersonalizationRpogMutation = { __typename?: 'Mutation', savePersonalizationOptionGroup: { __typename?: 'SavePersonalizationOptionGroupResult', optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string }, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } };

export type EditPersonalizationOptionPage_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, groupByFeature: boolean, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> };

export const EditPersonalizationOptionPage_OptionCombinationFragmentDoc = gql`
    fragment EditPersonalizationOptionPage_OptionCombination on DesignPackageOptionCombination {
  id
  name
  options {
    id
  }
}
    `;
export const EditPersonalizationOptionPage_MaterialVariantFragmentDoc = gql`
    fragment EditPersonalizationOptionPage_MaterialVariant on MaterialVariant {
  id
  displayName
  listing {
    id
    brand {
      id
      name
    }
  }
  ...MaterialAttributeValuesForFilter
  featuredImage {
    id
    asset {
      id
      previewUrl(resizing: {width: 330, region: FULL})
    }
  }
}
    ${MaterialAttributeValuesForFilterFragmentDoc}`;
export const EditPersonalizationOptionPage_ProductFragmentDoc = gql`
    fragment EditPersonalizationOptionPage_Product on TakeoffLineItem {
  id
  active
  materialVariant {
    ...EditPersonalizationOptionPage_MaterialVariant
  }
  targetCombinations {
    id
    options {
      id
    }
  }
}
    ${EditPersonalizationOptionPage_MaterialVariantFragmentDoc}`;
export const EditPersonalizationOptionPage_Slot_TakeoffLineItemFragmentDoc = gql`
    fragment EditPersonalizationOptionPage_Slot_TakeoffLineItem on TakeoffLineItem {
  ...Named
  personalizationSlotOrder
  location {
    id
    displayLocationPath
  }
  materialVariant {
    id
  }
  products {
    ...EditPersonalizationOptionPage_Product
  }
}
    ${NamedFragmentDoc}
${EditPersonalizationOptionPage_ProductFragmentDoc}`;
export const EditPersonalizationOptionPage_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment EditPersonalizationOptionPage_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  options {
    id
    name
  }
  groupByFeature
}
    `;
export const EditPersonalizationOptionPageDocument = gql`
    query EditPersonalizationOptionPage($dpId: ID!, $rpavId: ID!, $rpogId: ID!, $isAdd: Boolean!, $forTliId: ID!, $hasTliId: Boolean!) {
  enumDetails {
    readyPlanOptionGroupPersonalizationType {
      code
      name
    }
  }
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    canEdit {
      ...PotentialOperationDetails
    }
    availableTargetGroups {
      ...EditPersonalizationOptionPage_ReadyPlanOptionGroup
    }
  }
  takeoffLineItem(id: $forTliId, versionId: $rpavId) @include(if: $hasTliId) {
    id
    ...EditPersonalizationOptionPage_Slot_TakeoffLineItem
    targetGroups {
      id
    }
    products {
      id
      materialVariant {
        id
        ...EditPersonalizationOptionPage_MaterialVariant
      }
    }
  }
  readyPlan(id: $dpId, versionId: $rpavId) @skip(if: $isAdd) {
    id
    optionGroups(filter: {id: [$rpogId]}) {
      id
      name
      marketingDescription
      personalizationTargetGroups {
        id
      }
      levels
      displayPackageOptionsAsSingleProduct
      groupByFeature
      personalizationPlaceholders {
        id
        personalizationRpoShadowPlaceholder {
          id
          products {
            id
            materialVariant {
              ...EditPersonalizationOptionPage_MaterialVariant
            }
            options {
              id
            }
            placeholder {
              id
              materialVariant {
                id
              }
            }
            location {
              id
            }
          }
        }
        personalizationPlaceholderControlledSlots {
          ...EditPersonalizationOptionPage_Slot_TakeoffLineItem
        }
      }
      personalizationType {
        code
        name
      }
      options {
        id
        name
        materialVariant {
          id
          ...EditPersonalizationOptionPage_MaterialVariant
        }
        personalizationTargetCombinations {
          id
          options {
            id
            name
          }
        }
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${EditPersonalizationOptionPage_ReadyPlanOptionGroupFragmentDoc}
${EditPersonalizationOptionPage_Slot_TakeoffLineItemFragmentDoc}
${EditPersonalizationOptionPage_MaterialVariantFragmentDoc}`;

/**
 * __useEditPersonalizationOptionPageQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionPageQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *      rpogId: // value for 'rpogId'
 *      isAdd: // value for 'isAdd'
 *      forTliId: // value for 'forTliId'
 *      hasTliId: // value for 'hasTliId'
 *   },
 * });
 */
export function useEditPersonalizationOptionPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables> & ({ variables: EditPersonalizationOptionPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>(EditPersonalizationOptionPageDocument, options);
      }
export function useEditPersonalizationOptionPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>(EditPersonalizationOptionPageDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>;
export function useEditPersonalizationOptionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPageQuery | undefined, EditPersonalizationOptionPageQueryVariables>;
export function useEditPersonalizationOptionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>(EditPersonalizationOptionPageDocument, options);
        }
export type EditPersonalizationOptionPageQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPageQuery>;
export type EditPersonalizationOptionPageLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPageLazyQuery>;
export type EditPersonalizationOptionPageSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPageSuspenseQuery>;
export type EditPersonalizationOptionPageQueryResult = ApolloReactCommon.QueryResult<EditPersonalizationOptionPageQuery, EditPersonalizationOptionPageQueryVariables>;
export const EditPersonalizationOptionPage_MaterialVariantDocument = gql`
    query EditPersonalizationOptionPage_MaterialVariant($id: ID!) {
  materialVariant(id: $id) {
    ...EditPersonalizationOptionPage_MaterialVariant
  }
}
    ${EditPersonalizationOptionPage_MaterialVariantFragmentDoc}`;

/**
 * __useEditPersonalizationOptionPage_MaterialVariantQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionPage_MaterialVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionPage_MaterialVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionPage_MaterialVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditPersonalizationOptionPage_MaterialVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables> & ({ variables: EditPersonalizationOptionPage_MaterialVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>(EditPersonalizationOptionPage_MaterialVariantDocument, options);
      }
export function useEditPersonalizationOptionPage_MaterialVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>(EditPersonalizationOptionPage_MaterialVariantDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionPage_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>;
export function useEditPersonalizationOptionPage_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPage_MaterialVariantQuery | undefined, EditPersonalizationOptionPage_MaterialVariantQueryVariables>;
export function useEditPersonalizationOptionPage_MaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>(EditPersonalizationOptionPage_MaterialVariantDocument, options);
        }
export type EditPersonalizationOptionPage_MaterialVariantQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_MaterialVariantQuery>;
export type EditPersonalizationOptionPage_MaterialVariantLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_MaterialVariantLazyQuery>;
export type EditPersonalizationOptionPage_MaterialVariantSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_MaterialVariantSuspenseQuery>;
export type EditPersonalizationOptionPage_MaterialVariantQueryResult = ApolloReactCommon.QueryResult<EditPersonalizationOptionPage_MaterialVariantQuery, EditPersonalizationOptionPage_MaterialVariantQueryVariables>;
export const EditPersonalizationOptionPage_CombinationsDocument = gql`
    query EditPersonalizationOptionPage_Combinations($dpId: ID!, $rpavId: ID!, $targetGroupIds: [ID!]!) {
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    combinations(optionGroupIds: $targetGroupIds) {
      ...DesignPackageProductCardPage_OptionCombination
    }
  }
}
    ${DesignPackageProductCardPage_OptionCombinationFragmentDoc}`;

/**
 * __useEditPersonalizationOptionPage_CombinationsQuery__
 *
 * To run a query within a React component, call `useEditPersonalizationOptionPage_CombinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalizationOptionPage_CombinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPersonalizationOptionPage_CombinationsQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *      targetGroupIds: // value for 'targetGroupIds'
 *   },
 * });
 */
export function useEditPersonalizationOptionPage_CombinationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables> & ({ variables: EditPersonalizationOptionPage_CombinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>(EditPersonalizationOptionPage_CombinationsDocument, options);
      }
export function useEditPersonalizationOptionPage_CombinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>(EditPersonalizationOptionPage_CombinationsDocument, options);
        }
// @ts-ignore
export function useEditPersonalizationOptionPage_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>;
export function useEditPersonalizationOptionPage_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditPersonalizationOptionPage_CombinationsQuery | undefined, EditPersonalizationOptionPage_CombinationsQueryVariables>;
export function useEditPersonalizationOptionPage_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>(EditPersonalizationOptionPage_CombinationsDocument, options);
        }
export type EditPersonalizationOptionPage_CombinationsQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_CombinationsQuery>;
export type EditPersonalizationOptionPage_CombinationsLazyQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_CombinationsLazyQuery>;
export type EditPersonalizationOptionPage_CombinationsSuspenseQueryHookResult = ReturnType<typeof useEditPersonalizationOptionPage_CombinationsSuspenseQuery>;
export type EditPersonalizationOptionPage_CombinationsQueryResult = ApolloReactCommon.QueryResult<EditPersonalizationOptionPage_CombinationsQuery, EditPersonalizationOptionPage_CombinationsQueryVariables>;
export const SavePersonalizationRpogDocument = gql`
    mutation SavePersonalizationRpog($input: SavePersonalizationOptionGroupInput!) {
  savePersonalizationOptionGroup(input: $input) {
    optionGroup {
      id
    }
    version {
      id
    }
  }
}
    `;

/**
 * __useSavePersonalizationRpogMutation__
 *
 * To run a mutation, you first call `useSavePersonalizationRpogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonalizationRpogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonalizationRpogMutation, { data, loading, error }] = useSavePersonalizationRpogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePersonalizationRpogMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePersonalizationRpogMutation, SavePersonalizationRpogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePersonalizationRpogMutation, SavePersonalizationRpogMutationVariables>(SavePersonalizationRpogDocument, options);
      }
export type SavePersonalizationRpogMutationHookResult = ReturnType<typeof useSavePersonalizationRpogMutation>;
export type SavePersonalizationRpogMutationResult = ApolloReactCommon.MutationResult<SavePersonalizationRpogMutation>;